import { useEffect, useState } from 'react'
import style from './style.module.scss'
import useDebounce from 'src/utils/Hooks/useDebounce'

interface IProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  value?: string
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
}

const TextArea = ({ label, value = '', onChange, className, ...props }: IProps) => {
  const [textValue, setTextValue] = useState(value)
  const [event, setEvent] = useState<React.ChangeEvent<HTMLTextAreaElement> | null>(null)
  const debouncedValue = useDebounce(event, 400)

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextValue(e.target.value)
    setEvent(e)
  }

  useEffect(() => {
    if (value !== textValue) {
      setTextValue(value)
    }
  }, [value])

  useEffect(() => {
    if ((debouncedValue || debouncedValue === '') && onChange) {
      onChange(debouncedValue as React.ChangeEvent<HTMLTextAreaElement>)
    }
  }, [debouncedValue])

  return (
    <div className={style.textarea + ' ' + className}>
      <textarea value={textValue} onChange={(e) => handleChange(e)} placeholder="p" {...props} />
      <span>{label}</span>
    </div>
  )
}

export default TextArea
